/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataPageReqVo
 */
export interface NodataPageReqVo {
    /**
     * 当前页，默认1
     * @type {number}
     * @memberof NodataPageReqVo
     */
    currentPage?: number;
    /**
     * 每页条数，默认30，最大1000
     * @type {number}
     * @memberof NodataPageReqVo
     */
    pageSize?: number;
    /**
     * 国家ID（1=韩国 2=中国），必传，按 warehouse.nation_id 过滤
     * @type {number}
     * @memberof NodataPageReqVo
     */
    nationId: number;
    /**
     * 左侧 Tab 无数据类型（NodataTypeEnum 1/2/3），中国忽略
     * @type {number}
     * @memberof NodataPageReqVo
     */
    nodataType?: number;
    /**
     * 废弃 Tab 内「无数据类型」筛选项（1=一般来源 2=返送来源），仅 nodataType=3 时生效
     * @type {number}
     * @memberof NodataPageReqVo
     */
    sourceNodataType?: number;
    /**
     * 仓库ID（精确）
     * @type {number}
     * @memberof NodataPageReqVo
     */
    warehouseId?: number;
    /**
     * 会员编号（user_account 精确）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    postNo?: string;
    /**
     * 无数据编号（id 精确）
     * @type {number}
     * @memberof NodataPageReqVo
     */
    id?: number;
    /**
     * 货位号（location_detail_code 精确）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    locationNo?: string;
    /**
     * 快递单号（tracking_number 模糊，唯一非精确字段）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    trackingNumber?: string;
    /**
     * Coupang入库码（coupang_inbound_code 精确，韩国返送/废弃 Tab）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    coupangInboundCode?: string;
    /**
     * 无数据状态（nodata_status 精确，见 NodataStatusEnum 1/2/3/4）
     * @type {number}
     * @memberof NodataPageReqVo
     */
    nodataStatus?: number;
    /**
     * 登记开始日期（yyyy-MM-dd，含当日 00:00:00）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    startTime?: string;
    /**
     * 登记结束日期（yyyy-MM-dd，含当日 23:59:59）
     * @type {string}
     * @memberof NodataPageReqVo
     */
    endTime?: string;
}

/**
 * Check if a given object implements the NodataPageReqVo interface.
 */
export function instanceOfNodataPageReqVo(value: object): value is NodataPageReqVo {
    if (!('nationId' in value) || value['nationId'] === undefined) return false;
    return true;
}

export function NodataPageReqVoFromJSON(json: any): NodataPageReqVo {
    return NodataPageReqVoFromJSONTyped(json, false);
}

export function NodataPageReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataPageReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'nationId': json['nationId'],
        'nodataType': json['nodataType'] == null ? undefined : json['nodataType'],
        'sourceNodataType': json['sourceNodataType'] == null ? undefined : json['sourceNodataType'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'postNo': json['postNo'] == null ? undefined : json['postNo'],
        'id': json['id'] == null ? undefined : json['id'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'nodataStatus': json['nodataStatus'] == null ? undefined : json['nodataStatus'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
    };
}

export function NodataPageReqVoToJSON(json: any): NodataPageReqVo {
    return NodataPageReqVoToJSONTyped(json, false);
}

export function NodataPageReqVoToJSONTyped(value?: NodataPageReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'nationId': value['nationId'],
        'nodataType': value['nodataType'],
        'sourceNodataType': value['sourceNodataType'],
        'warehouseId': value['warehouseId'],
        'postNo': value['postNo'],
        'id': value['id'],
        'locationNo': value['locationNo'],
        'trackingNumber': value['trackingNumber'],
        'coupangInboundCode': value['coupangInboundCode'],
        'nodataStatus': value['nodataStatus'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

